import React from "react";

export default function Terms() {
  return (
    <section className="ae-section pt-28">
      <div className="ae-container max-w-3xl">
        <div className="ae-eyebrow mb-3">Legal</div>
        <h1 className="font-display text-4xl font-semibold text-[#101827] mb-6">Terms & Conditions</h1>
        <div className="prose-ae space-y-4 text-[#1F2937] leading-relaxed">
          <h2 className="font-display text-xl font-semibold">Consultancy Scope</h2>
          <p>Apurba Estate provides property advisory, digital land surveying, documentation assistance and allied technical services. Each engagement is governed by its own written scope and commercial terms.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Property Listing Accuracy</h2>
          <p>Listings are shared based on information provided by sellers, our observations and reasonable checks. Buyers must independently verify title, documents, measurements and permissions before any transaction.</p>
          <h2 className="font-display text-xl font-semibold mt-6">User Responsibilities</h2>
          <p>You are responsible for providing accurate information in enquiries and for using our website in compliance with applicable law.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Third-party Services</h2>
          <p>Where third-party service providers are used (e.g., payment processing), their terms apply to that specific interaction.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Payments</h2>
          <p>Fees applicable to specific services, including advance consultation fees, will be communicated before you commit. Payments are processed via trusted gateways.</p>
          <h2 className="font-display text-xl font-semibold mt-6">Limitation of Liability</h2>
          <p>To the maximum extent permitted by applicable law, Apurba Estate's liability for any claim arising out of the use of this website or services is limited to the fees paid for the specific service in question.</p>
          <p className="text-sm text-[#64748B] mt-6">We may update these terms periodically; the current version will apply.</p>
        </div>
      </div>
    </section>
  );
}
